import _ from 'lodash';
import React from 'react';
import classNames from 'classnames';

import IconButton from 'components/IconButton';
import DateRangePicker from 'components/DateRangePicker';

import arrowDownIcon from 'assets/icons/arrow-down.svg';
import arrowRightIcon from 'assets/icons/arrow-right.svg';

import './styles.css';

export const BottomRightFixedCustomOverlay = ({
  children,
  onBlur,
  onFocus,
  tabIndex,
  input
}: any) => {
  // Custom Overlay will be fixed to bottom right from input

  const position = input.parentElement.getBoundingClientRect();

  return (
    <div
      className="BottomRightFixedCustomOverlay"
      onBlur={onBlur}
      onFocus={onFocus}
      tabIndex={tabIndex}
      style={{right: 20, top: position.top + position.height}}>
      <div className="OverlayWrapper colab-small-border-radius">{children}</div>
    </div>
  );
};

export const TopRightFixedCustomOverlay = ({
  children,
  onBlur,
  onFocus,
  tabIndex,
  input
}: any) => {
  // Custom Overlay will be fixed to top right from input

  const position = input.parentElement.getBoundingClientRect();

  return (
    <div
      className="BottomRightFixedCustomOverlay"
      onBlur={onBlur}
      onFocus={onFocus}
      tabIndex={tabIndex}
      style={{right: 20, top: position.top - 235}}>
      <div className="OverlayWrapper colab-small-border-radius">{children}</div>
    </div>
  );
};

interface DateRangeFilterProps {
  label: string;
  start: string | null;
  end: string | null;
  fieldName: string;
  startFieldName?: string;
  endFieldName?: string;
  overlayComponent?: React.ComponentType;
  onChange: (fieldName: string, date: string) => void;
  classNameForTesting?: string;
}

class DateRangeFilter extends React.Component<DateRangeFilterProps> {
  state = {
    sectionOpened: false
  };

  toggleDateSection = () => {
    this.setState({sectionOpened: !this.state.sectionOpened});
  };

  dateFilterHandler = (field, value) => {
    if (field === 'startDate') {
      if (this.props.startFieldName) {
        this.props.onChange(this.props.startFieldName, value);
      } else {
        this.props.onChange(`${this.props.fieldName}Start`, value);
      }
    }

    if (field === 'endDate') {
      if (this.props.endFieldName) {
        this.props.onChange(this.props.endFieldName, value);
      } else {
        this.props.onChange(`${this.props.fieldName}End`, value);
      }
    }
  };

  render() {
    const overlayComponent =
      this.props.overlayComponent || BottomRightFixedCustomOverlay;

    return (
      <div
        className={classNames(
          'FilterSection DateRangeFilter',
          {
            'FilterSection--opened': this.state.sectionOpened
          },
          this.props.classNameForTesting
        )}>
        <div className="FilterSection__header colab-centered-v colab-bold">
          <IconButton
            src={arrowRightIcon}
            srcActive={arrowDownIcon}
            alt="Toggle section"
            onClick={this.toggleDateSection}
            active={this.state.sectionOpened}
          />
          <div>{this.props.label}</div>
        </div>
        <div className="FilterSection__content">
          <DateRangePicker
            className="colab-small-border-radius"
            overlayComponent={overlayComponent}
            start={this.props.start}
            end={this.props.end}
            handleChange={this.dateFilterHandler}
          />
        </div>
      </div>
    );
  }
}

export default DateRangeFilter;
